import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { BKJTextInputFieldSet, BKJTextInputLabel, BKJTextInputRequiredAsterisk, } from '../BKJTextInput/BKJTextInput.styled.js';
import { BKJFileInputLabel, BKJFileInputText, CloseIcon, DocumentIcon, ErrorText, FileWrapper, InnerWrapper, Input, } from './BKJFileInput.styled.js';
import i18next from 'i18next';
export const BKJFileInput = (props) => {
    const { className, labelProps, label, required, name, disabled, error, value, onChange = () => { }, onClear, ...rest } = props;
    const inputRef = useRef();
    const handleChange = useCallback((event) => {
        const selectedFile = event?.target?.files && event.target.files[0];
        if (selectedFile) {
            onChange({
                target: { ...event.target, name, value: selectedFile },
            });
        }
    }, [name, onChange]);
    const handleClear = (e) => {
        e.stopPropagation();
        onChange({ target: { value: undefined, name } });
        if (inputRef.current) {
            inputRef.current.value = '';
        }
        if (onClear)
            onClear();
    };
    return (_jsxs(BKJTextInputFieldSet, { children: [props.label && (_jsxs(BKJTextInputLabel, { ...labelProps, variant: "RoundEdges", elementType: "Label", children: [props.label, props.required && _jsx(BKJTextInputRequiredAsterisk, { children: "\u00A0*" })] })), _jsxs(InnerWrapper, { error: !!error, children: [value && _jsx(CloseIcon, { iconName: "CloseBold", onClick: handleClear }), _jsxs(FileWrapper, { isFileSelected: !!value, children: [_jsx(DocumentIcon, { iconName: "Document" }), _jsx(BKJFileInputText, { title: value && value.name, error: !!error, isFileSelected: !!value, children: !!value ? value.name : i18next.t('translations:NO_FILE_SELECTED') }), _jsx(Input, { ...rest, ref: inputRef, type: "file", onChange: handleChange })] }), _jsx(BKJFileInputLabel, { onClick: () => inputRef.current?.click(), children: !!value ? i18next.t('translations:REPLACE') : i18next.t('translations:SELECT_A_FILE') })] }), _jsx(ErrorText, { children: error })] }));
};
//# sourceMappingURL=BKJFileInput.js.map